{
  "meta": {
    "title":       "GlobalAnka | Uluslararası İş Gücü ve Kurumsal Danışmanlık",
    "description": "GlobalAnka, uluslararası iş gücü yönetimi, hukuki danışmanlık ve İK çözümlerinde Türkiye'nin prestijli ortağı."
  },
  "hero": {
    "tagline":  "Prestijli Çözüm Ortağı",
    "title":    "GlobalAnka: Kurumsal Çözümleriniz İçin",
    "titleAccent": "Stratejik Ortak.",
    "subtitle": "Dünya çapında yetenek ağımızı işletmenizin hedefleriyle buluşturuyoruz. Sınırların ötesinde bir verimlilik ve büyüme vizyonu.",
    "ctaPrimary":   "Hizmetlerimizi Keşfedin",
    "ctaSecondary": "Referanslar",
    "ctaPrimaryPath": "/contact",
    "ctaSecondaryPath": "/portfolio",
    "scrollHint":   "Keşfet"
  },
  "services": {
    "title":    "Hizmetlerimiz",
    "subtitle": "Küresel yetenek ağımız ve uzman kadromuzla işletmenizin ihtiyaçlarına özel çözümler sunuyoruz.",
    "recruitment": {
      "title": "Küresel İş Gücü Yönetimi",
      "desc":  "Yüksek nitelikli uzmanları, sınır ötesi projelerinizle senkronize ediyoruz. Global yetenek havuzuna doğrudan erişim sağlayın.",
      "backgroundImage": "",
      "icon": "HiOutlineUsers"
    },
    "consulting": {
      "title": "Stratejik Danışmanlık",
      "desc":  "Pazar analizi ve operasyonel verimlilik odaklı kurumsal yol haritaları.",
      "backgroundImage": "",
      "icon": "HiOutlineGlobeAlt"
    },
    "compliance": {
      "title": "Risk ve Uyum",
      "desc":  "Uluslararası standartlarda regülasyon uyumu ve risk yönetimi çözümleri.",
      "backgroundImage": "",
      "icon": "HiOutlineShieldCheck"
    },
    "digital": {
      "title": "Dijital Dönüşüm Mimarisi",
      "desc":  "İşletmenizi geleceğe taşıyacak teknolojik altyapı ve yazılım çözümleriyle modernizasyon sürecinizi yönetiyoruz.",
      "backgroundImage": "",
      "icon": "HiOutlineCpuChip"
    }
  },
  "stats": {
    "title":           "Rakamlarla GlobalAnka",
    "countries":       "Ülkede Operasyon",
    "countriesValue":  "12+",
    "consultants":     "Uzman Danışman",
    "consultantsValue":"500+",
    "satisfaction":    "Müşteri Memnuniyeti",
    "satisfactionValue":"100%",
    "support":         "Global Destek",
    "supportValue":    "24/7",
    "items": [
      { "end": 12, "suffix": "+", "label": "Ülkede Operasyon", "is_active": 1 },
      { "end": 500, "suffix": "+", "label": "Uzman Danışman", "is_active": 1 },
      { "end": 100, "suffix": "%", "label": "Müşteri Memnuniyeti", "is_active": 1 }
    ]
  },
  "whyList": [
    { "text": "Küresel yetenek ağı — 40+ ülkede aktif bağlantılar", "is_active": 1 },
    { "text": "İŞKUR lisanslı, %100 yasal uyumluluk garantisi", "is_active": 1 },
    { "text": "Senior danışman atamanız 72 saatten kısa sürede", "is_active": 1 },
    { "text": "7/24 müşteri başarı ekibi desteği", "is_active": 1 }
  ],
  "portfolio": {
    "label": "Referanslar",
    "title": "Başarı Hikayelerimiz",
    "viewAll": "Tümünü Gör",
    "viewAllPath": "/portfolio"
  },
  "contactSection": {
    "label": "İletişim"
  },
  "whyUs": {
    "title":    "Neden GlobalAnka?",
    "subtitle": "Kurumsal strateji ve operasyonel mükemmellikte yeni bir standart tanımlıyoruz."
  },
  "partners": {
    "title": "İş Ortaklarımız"
  },
  "leadForm": {
    "title":          "Projeni Anlat",
    "subtitle":       "Uzmanlarımız en kısa sürede seninle iletişime geçecek.",
    "companyName":    "Şirket Adı",
    "companyNamePH":  "Örn: Anka Holding A.Ş.",
    "sector":         "Sektör",
    "sectorPH":       "Sektörünüzü seçin",
    "employeeCount":  "Çalışan Sayısı",
    "employeeCountPH":"Aralık seçin",
    "email":          "E-Posta (Kurumsal)",
    "emailPH":        "kurumsal@sirketiniz.com",
    "phone":          "Telefon (Opsiyonel)",
    "phonePH":        "+90 5XX XXX XX XX",
    "message":        "Mesajınız",
    "messagePH":      "Projeniz veya ihtiyaçlarınız hakkında kısa bir bilgi verin...",
    "submit":         "TEKLİF TALEBİNİ GÖNDER",
    "kvkkNote":       "Gönder butonuna basarak KVKK Aydınlatma Metni'ni okuduğunuzu kabul edersiniz.",
    "kvkkLink":       "KVKK Aydınlatma Metni",
    "success":        "Talebiniz alındı. Uzmanlarımız en kısa sürede sizinle iletişime geçecek.",
    "error":          "Bir hata oluştu. Lütfen tekrar deneyin.",
    "loading":        "Gönderiliyor..."
  }
}
